import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
export const DisconnectAccountingModal = (param)=>{
    let { accountingFullName, testId, onDismiss } = param;
    const { t: accountingTexts } = useLocaleKeys('integrations.accounting');
    const { t: commonTexts } = useLocaleKeys('common');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'accounting_setup_confirm'
            },
            secondaryButton: {
                name: 'accounting_setup_cancel'
            }
        },
        testId: testId,
        title: accountingTexts.disconnectFromTitle({
            accountingFullName
        }),
        content: /*#__PURE__*/ _jsx(Typography, {
            children: accountingTexts.confirmDisconnect({
                accountingFullName
            })
        }),
        onCloseButtonClick: ()=>onDismiss(false),
        onPrimaryButtonClick: ()=>onDismiss(true),
        primaryButtonLabel: commonTexts.buttons.disconnect(),
        onSecondaryButtonClick: ()=>onDismiss(false),
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        skin: "danger"
    });
};
